<template>
  <div>
    <plan-stats ref="planStats" @statChange="changeParam"></plan-stats>
    <div class="flex flex-wrap">
      <div class="w-full">
        <!-- <div class="relative flex flex-col min-w-0 break-words  w-full border border-blueGray-200 rounded-lg" v-if="has('plan.view') && has('plans.show')"> -->
        <div class="relative flex flex-col min-w-0 break-words w-full border border-blueGray-200 rounded-lg mb-3">
          <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 px-3 flex-row">
            <li class="-mb-px mr-2 last:mr-0" v-if="has('plan.view')">
              <a class="text-xs px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-blueGray-600 bg-white': openTab !== 1, 'text-white bg-blueGray-900': openTab === 1}">
                <i class="pi pi-barcode" style="font-size: 10px;"></i> User Plans
              </a>
            </li>
            <li class="-mb-px mr-2 last:mr-0" v-if="has('plans.show')">
              <a class="text-xs px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-blueGray-600 bg-white': openTab !== 2, 'text-white bg-blueGray-900': openTab === 2}">
                <i class="pi pi-cog" style="font-size: 10px;"></i> Manage
              </a>
            </li>
          </ul>
        </div>

        <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
          <div class="flex-auto">
            <div class="tab-content tab-space">
              <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}" class="flex flex-wrap">
                <div class="w-full px-4" :class="{'lg:w-8/12': Object.values(planUserModel).length > 0}">
                  <card-user-plan-list
                    :plans="userPlan()"
                    :param="param"
                    @selectedPlan="changePlanUser"
                    @filter="handleFilterClick"
                    @applyPreset="handleApplyPreset"
                    @download="handleDownloadSummary"
                  ></card-user-plan-list>
                </div>
                <transition name="bounce">
                  <div class="w-full lg:w-4/12 px-4" v-if="Object.values(planUserModel).length > 0">
                    <card-user-plan :selectedPlan="planUserModel" @close="handleCloseUserPlan" ></card-user-plan>
                  </div>
                </transition>
              </div>

              <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}" class="flex flex-wrap">
                <transition name="bounce">
                  <div class="w-full px-4" :class="{'lg:w-8/12': showPlanForm}">
                    <card-plan-list :plans="plans()" @selectedPlan="openPlanForm" @create="openPlanForm({})" />
                  </div>
                </transition>
                <transition name="bounce">
                  <div class="w-full lg:w-4/12 px-4" v-if="showPlanForm">
                    <card-plans :selectedPlan="plan" @close="handleClosePlanForm"></card-plans>
                  </div>
                </transition>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardUserPlan from "@/components/Cards/CardUserPlan.vue";
import CardUserPlanList from "@/components/Cards/CardUserPlanList.vue";
import PlanStats from "@/components/Stats/PlanStats.vue";
import { mapActions, mapGetters } from 'vuex';
import { createToaster } from "@meforma/vue-toaster";
import CardPlans from "@/components/Cards/CardPlans.vue";
import CardPlanList from "@/components/Cards/CardPlanList.vue";
const toaster = createToaster({ /* options */ });

export default {
  components: {
    PlanStats,
    CardUserPlan,
    CardUserPlanList,
    CardPlanList,
    CardPlans
  },
  data() {
    return {
      plan: {},
      planUserModel: {},
      openTab: 1,
      param: {},
      showPlanForm: false
    }
  },
  mounted() {
    this.getAllPlans();
    this.fetchPlanUser()
  },
  methods: {
    ...mapActions([
      "getAllPlans", 
      "fetchPlanUser"
    ]),
    ...mapGetters([
      "plans", 
      "userPlan"
    ]),
    // Opens the create/edit panel for a given plan (or {} for a brand-new one) —
    // the plan list takes the whole section until this is triggered.
    openPlanForm(plan) {
      this.plan = plan
      this.showPlanForm = true
    },
    handleClosePlanForm() {
      this.showPlanForm = false
    },
    changePlanUser(planUser) {
      this.planUserModel = planUser
    },
    changeParam(param) {
      this.param = param
      
      this.fetchPlanUser(param).then( response => {
        if ( param.get_csv ) {
          // create file link in browser's memory
          const href = window.URL.createObjectURL(response);
          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download','plans.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          toaster.success("Report downloaded Successfully");
        }
      })
    },
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    handleCloseUserPlan(){
      this.planUserModel = {}
    },
    // The Filter/Download/date-preset controls live on CardUserPlanList.vue's own
    // header now, but the actual filtering/summary logic still belongs to
    // PlanStats.vue (it owns the FilterModal, business/plan option lists, and the
    // summary fetch) — so these just forward the click through to it via $ref
    // instead of duplicating that logic here.
    handleFilterClick() {
      this.$refs.planStats.toggleFilterModal()
    },
    handleApplyPreset(preset) {
      this.$refs.planStats.applyDatePreset(preset)
    },
    handleDownloadSummary() {
      this.$refs.planStats.downloadSummary()
    }
  }
};
</script>

<style scoped>
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
